import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM7 4C6.30964 4 5.75 4.55964 5.75 5.25C5.75 5.66421 5.41421 6 5 6C4.58579 6 4.25 5.66421 4.25 5.25C4.25 3.73122 5.48122 2.5 7 2.5C8.51878 2.5 9.75 3.73122 9.75 5.25C9.75 6.50878 8.90425 7.57002 7.75 7.89648C7.75 8.3107 7.41421 8.64648 7 8.64648C6.58579 8.64648 6.25 8.3107 6.25 7.89648V7.25C6.25 6.83579 6.58579 6.5 7 6.5C7.69036 6.5 8.25 5.94036 8.25 5.25C8.25 4.55964 7.69036 4 7 4ZM8 10.5C8 11.0523 7.55229 11.5 7 11.5C6.44771 11.5 6 11.0523 6 10.5C6 9.94771 6.44771 9.5 7 9.5C7.55229 9.5 8 9.94771 8 10.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }